import { useSegment } from '@/third-party/segment'
import { defineStore, storeToRefs } from 'pinia'
import { ref, type Ref } from 'vue'
import { getWindow } from '@/helpers/globals'

const useWishlistTriggerStore = defineStore('wishlistTrigger', () => {
    const savedProductsModalOpen = ref(false)

    const { track } = useSegment()

    const toggleSavedProductsModal = () => {
        if (!savedProductsModalOpen.value) {
            const url = getWindow()?.location.href

            if (!url) {
                return
            }

            const event_name = 'saved_products_modal_open'

            track(`custom_${event_name}`, {
                param1: 'Save for later',
                param2: event_name,
                param3: 'Header icon click',
                param4: url,
                url,
                event_name,
            })
        }

        savedProductsModalOpen.value = !savedProductsModalOpen.value
    }

    return {
        savedProductsModalOpen,
        toggleSavedProductsModal,
    }
})

export const useWishlistTrigger = (): {
    savedProductsModalOpen: Ref<boolean, boolean>
    toggleSavedProductsModal: () => void
} => {
    const store = useWishlistTriggerStore()
    const { toggleSavedProductsModal } = store
    const { savedProductsModalOpen } = storeToRefs(store)

    return {
        toggleSavedProductsModal,
        savedProductsModalOpen,
    }
}
